export const EventNames = {
    INT_CLICK_INSTALL: 'Integrations: click install',
    INT_SELECT_INTEGRATION: 'Integrations: select an integration',
}